import React from 'react';
import { connect } from 'react-redux';
import config from "config"
import axios from 'axios';
import toastr from "toastr"
import { finalize } from "actions/URLfinalizer";
import MainMenu from 'components/common/mainmenu';
import FAQText from "./FAQText"
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
class FAQ extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			subject: "",
			body: "",
			subjectError: false,
			bodyError: false
		};
	}

	submit() {
		var ok1 = (this.state.subject.length > 0);
		var ok2 = (this.state.body.length > 0);
		if (ok1 && ok2) {
			var form = {
				subject: this.state.subject,
				body: this.state.body
			}
			toastr.info("Sending...");
			axios.post(finalize(config.api.root + `/help`), form)
				.then((response) => {
					toastr.remove();
					toastr.success("Submit successfully !");
				}).catch((error) => {
					toastr.remove();
					toastr.success("Submit failed !");
				});
		}
		this.setState({
			subjectError: !ok1,
			bodyError: !ok2
		});
	}

	onChange(key, e) {
		var st = {};
		st[key] = e.target.value;
		this.setState(st);
	}

	render() {
		return (
			<div className="faq-page">
				<StickyMenu
					withStickyHeader={false}
				>
					<MainMenu
						overviewIsActive={false}
						comparisonIsActive={false}
						onlyLeftMenu={true}
					/>
					<StatsMenu leftItemBold="FAQ" />
				</StickyMenu>
				<div className="page-content page-content_padding-modifier">
					<div className="clearfix">
						<div className="col-lg-8 no--padding">
							<div className="faq-table box--shadow bg--white">
								<div className="faq-header">
									<p>Frequently asked questions</p>
								</div>
								<table>
									<tbody>
										{FAQText.map((item) => {
											return (
												<tr key={item.id}>
													<td>
														{item.question}
													</td>
													<td style={{ whiteSpace: 'pre-wrap' }}>
														{item.answer}
													</td>
												</tr  >
											);
										})
										}
									</tbody>
								</table>
							</div>
						</div>

						<div className="col-lg-4 no--padding">
							<div className="feedback--container">
								<div className="feedback--container--padding bg--white box--shadow">
									<h4>Contact SenzoLive</h4>
									<p>Please send your message to SenzoLive's support team.</p>

									<form className="feedback ">
										<div className="feedback-subject">
											<label>Subject<span className="required">*</span></label>
											<input
												type="text"
												value={this.state.subject}
												className={this.state.subjectError ? "has-error" : ""}
												onChange={(e) => this.onChange("subject", e)}
											/>
										</div>
										<div className="feedback-message">
											<label>Message<span className="required">*</span></label>
											<textarea
												rows="4"
												value={this.state.body}
												className={this.state.bodyError ? "has-error" : ""}
												onChange={(e) => this.onChange("body", e)}
											></textarea>
										</div>
										<div className="feedback-submit">
											<button className="btn-small" style={{ width: "230px" }} onClick={() => this.submit()}>Send Message</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div >
			</div >



		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(null, mapDispatchToProps)(FAQ);


// WEBPACK FOOTER //
// ./src/components/pages/faq/index.jsx